package com.eladfinish.bible.contest.common.usecases

class AddGershaimUseCase {

    operator fun invoke(otiot: String): String =
        // בדיקה זו נועדה למקרה שהיו כבר גרש או גרשיים באותיות (כתוצאה מהכנסתם בטבלאות של google spreadsheet)
        if (otiot.contains("['\"]".toRegex())) {
            otiot
        } else {
            if (otiot.length == 1) {
                "$otiot'"
            } else {
                otiot.take(otiot.lastIndex) + '"' + otiot.last()
            }
        }

}
